exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-1c060452]{-webkit-transition:0.3s all ease;-o-transition:0.3s all ease;transition:0.3s all ease;top:9px;right:-10px;position:absolute}.search.open-search[data-v-1c060452]{width:300px}.search.closed-search[data-v-1c060452]{width:35px}@media screen and (min-width: 1350px){.search.closed-search[data-v-1c060452]{width:300px}}.fs25[data-v-1c060452]{font-size:25px}\n", ""]);

// exports
